export default "__VITE_ASSET__4cgk1N5t__"